import { define } from "../preactement/define";
import { SkipNav } from "../../SkipNav";
const attributes = ['href'];

/* eslint-disable @typescript-eslint/no-namespace */

/* eslint-enable */

define('ds-skip-nav', () => SkipNav, {
  attributes,
  events: ['onClick']
});